"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var userAgent_1 = require("./userAgent");
/**
 * Check to see if this is a Android device with major version 3, 4, or 5.
 * Those versions might be able to play dash, but will likely fail to do so
 * because of codec failure.
 */


var isOldAndroidWithDashSupport = function isOldAndroidWithDashSupport(window) {
  var android = userAgent_1.getAndroidVersion(window);
  return android !== null && android.major !== null && android.major >= 3 && android.major <= 4;
};

exports.supportsNativeHls = function (window) {
  // Safari can play native hls
  if (window.navigator.userAgent.match(/safari/i) !== null && window.navigator.userAgent.match(/chrom/i) === null) {
    return true;
  } // All iOS versions can play native hls


  if (userAgent_1.isIos(window)) {
    return true;
  } // Android >= 3 can play native hls


  var android = userAgent_1.getAndroidVersion(window);

  if (android !== null && android.major !== null && android.major >= 3) {
    return true;
  }

  return false;
};

exports.supportsDash = function (window) {
  return 'MediaSource' in window;
};

exports.getPreferredStreamingProtocol = function (window) {
  if (exports.supportsDash(window) && !isOldAndroidWithDashSupport(window)) {
    return 'dash';
  }

  if (exports.supportsNativeHls(window)) {
    return 'hls';
  }

  return null;
};